import { useState, useEffect } from 'react';

const useCityProfitsLogic = () => {
  const [itemsSelected, setItemsSelected] = useState([]);

  useEffect(() => {});
  return { itemsSelected, setItemsSelected };
};

export default useCityProfitsLogic;
